import React from 'react';
import Favorites from './Favorites';
import PageTitle from '../../components/PageTitle';
import PageBack from '../../components/PageBack';
import LoadingWrapper from '../../components/LoadingWrapper';
import { DataActions, ActionResult } from '../../components/LoadingWrapper/LoadingWrapper';
import LinkManager from '../../lib/LinkManager';
import { Favorites as FavoritesData, Identifier } from '../../types';
import FavoritesApi from '../../lib/FavoritesApi';

interface FavoriteActions extends DataActions {
    removeItem: (lessonId: Identifier) => Promise<ActionResult>,
}

type Props = {
    data: FavoritesData,
    actions: FavoriteActions,
}

const MappedFavorites = ({ data, actions }: Props) => (
    <Favorites
        favorites={data}
        onFavoriteRemoveClicked={(lessonId: Identifier) => actions.removeItem(lessonId)}
    />
);

class FavoritePage extends React.Component<Props> {
    render() {
        const WrappedFavorites = LoadingWrapper(
            MappedFavorites,
            () => FavoritesApi.getFavorites(),
            {
                removeItem: (lessonId: Identifier) => new Promise(
                    resolve => FavoritesApi.deleteFavorite(lessonId)
                        .then(() => resolve({ result: 'success', message: 'Aus Favoriten entfernt' }))
                        .catch(() => resolve({ result: 'error', message: 'Konnte nicht aus Favoriten entfernt werden' })),
                ),
            },
        );
        return (
            <>
                <PageTitle documentTitleParts={['Deine Favoriten']}>
                    Deine
                    <strong>Favoriten</strong>
                </PageTitle>
                <PageBack backlink={LinkManager.getMentalIndexLink()} />
                <WrappedFavorites />
            </>
        );
    }
}

export default FavoritePage;
